import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Dashboard/Sidebar';
import MainDashboard from './Dashboard/MainDashboard';
import Path1 from './Dashboard/Path1';
import Path2 from './Dashboard/Path2';
import Path3 from './Dashboard/Path3';
import Path4 from './Dashboard/Path4';
import LoginDashboard from './Dashboard/LoginDashboard';


import MenuIcon from '@mui/icons-material/Menu';

const Dashboard = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Detect mobile device
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 900;

  return (
    <div
      className="dashboard-container dashboard-bg"
      style={{
        width: '100vw',
        height: '100vh',
        minHeight: '100vh',
        minWidth: '100vw',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        paddingTop: 72,
      }}
    >
      {/* Hamburger menu for mobile */}
      {isMobile && (
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          style={{
            position: 'fixed',
            top: 80,
            left: 16,
            zIndex: 2000,
            background: 'rgba(10,34,64,0.98)',
            border: '1.5px solid #1e90ff',
            borderRadius: 8,
            padding: 8,
            color: '#e0f7fa',
            boxShadow: '0 2px 8px rgba(30,144,255,0.10)',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <MenuIcon />
        </button>
      )}
      {/* Sidebar as drawer on mobile, fixed on desktop */}
      {(!isMobile || mobileOpen) && (
        <aside
          style={{
            width: 240,
            height: '100%',
            minHeight: '100%',
            background: 'rgba(10,34,64,0.98)',
            color: '#e0f7fa',
            borderRight: '1.5px solid #1e90ff',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative', // Always relative so it scrolls with dashboard
            top: 0,
            left: undefined,
            zIndex: 1,
            boxShadow: 'none',
            transition: 'left 0.2s',
          }}
        >
          <Sidebar />
          {isMobile && (
            <button
              onClick={() => setMobileOpen(false)}
              style={{
                margin: 16,
                padding: 8,
                borderRadius: 8,
                border: 'none',
                background: '#1e90ff',
                color: '#fff',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Close
            </button>
          )}
        </aside>
      )}
      <main
        style={{
          flex: 1,
          height: '100%',
          minHeight: '100%',
          overflowY: 'auto',
          background: 'linear-gradient(135deg, #0a2240 0%, #1e3a5f 100%)',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: 0,
        }}
      >
        <Routes>
          <Route path="" element={<MainDashboard />} />
          <Route path="path1" element={<Path1 />} />
          <Route path="path2" element={<Path2 />} />
          <Route path="path3" element={<Path3 />} />
          <Route path="path4" element={<Path4 />} />
          <Route path="logindashboard" element={<LoginDashboard />} />
          <Route path="*" element={<Navigate to="." replace />} />          
        </Routes>
      </main>
      {/* No overlay needed; sidebar scrolls with dashboard */}
    </div>
  );
};

export default Dashboard;